<template>
  <div class="offer-list">
    <Offer v-for="(offer, index) in displayOffers"
    :key="offer.displayedOfferId" :offer="offer"
    :show-form="index === showIndex"
    :similar-submitted="similarSubmitted(offer, submittedList)"
    :similar-pending="similarSubmitted(offer, pendingList)"
    :pending-submits="pendingList"
    :program-search="programSearch"
    :wait="wait"
    :showIndex="showIndex"
    @submit-offer="$emit('submitOffer', $event)"
    @show="show(index)"
    @skip="skip(offer.displayedOfferId, $event)"
    @expired="$emit('expired', $event)"></Offer>
  </div>
</template>
<script>
import Offer from './Offer.vue'
export default {
  name: 'OfferList',
  props: ['offers', 'submitted', 'pending', 'programSearch', 'wait'],
  emits: ['skipOffer', 'submitOffer', 'expired'],
  components: {
    Offer
  },
  data () {
    return {
      showIndex: 0
    }
  },
  computed: {
    displayOffers () {
      return this.offers ?? []
    },
    submittedList () {
      return this.submitted ?? []
    },
    pendingList () {
      return this.pending ?? []
    }
  },
  methods: {
    skip (displayedOfferId, reason) {
      this.$emit('skipOffer', { displayedOfferId, reason })
    },
    show (index) {
      this.showIndex = index
    },
    similarSubmitted (offer, offerList) {
      if (Array.isArray(offer.offerList)) {
        offerList = offerList.filter((o) => typeof o !== 'undefined')
      }

      if (!offerList.length) {
        return false
      }

      if (offerList.map((submit) => submit.offerExternalNameId).includes(offer.offerExternalNameId)) {
        return true
      }

      var offerListExternalNameId = Array.prototype.concat.apply([], offerList.map((submit) => submit.externalNameId))
      var offersWithInclusiveOffer = offerList.filter((o) => o.externalNameInclusiveOfferId !== [] && o.externalNameId.includes(offer.offerExternalNameId))

      if (offersWithInclusiveOffer.length) {
        var shouldSkip = false

        offersWithInclusiveOffer.forEach((offerInclusive) => {
          if (!shouldSkip && (!offer.externalNameId.some(id => offerListExternalNameId.includes(id)) || !offerInclusive.externalNameInclusiveOfferId.includes(offer.id))) {
            shouldSkip = true
          }
        })

        return shouldSkip
      } else {
        return offer.externalNameId.some(id => offerListExternalNameId.includes(id))
      }
    }
  },
  watch: {
    offers (newOffers) {
      if (newOffers.length <= this.showIndex) {
        this.showIndex -= 1
      }
    }
  }
}
</script>

<style scoped>
.offer-list {
  border-radius: 4px;
}
</style>
